<div class="col-lg-12 p-0 pt-4">

  @if (contactsWithColors$ | async; as contacts) {
    <!-- CONTACT CARDS -->
    @if (contacts.length > 0) {
      <div class="contacts-grid">
        @for (contact of contacts; track contact) {
          @for (roles of getSortedContactRoles(contact.roles); track roles; let i = $index) {
            <div class="contact-card">
              <div #card>
                <div class="brand-header" [ngStyle]="{ 'background-color': contact.brandColor }">
                  <div class="brand-badge">{{contact.brandName}}</div>
                </div>
                <div class="card-content">
                  <div
                    class="role-badge"
                    [innerHTML]="getFMC_RoleName(roles.id)"
                    [ngStyle]="contact.hoverStyle">
                  </div>
                  <div class="contact-name">
                    {{ roles.brandName }}
                  </div>
                  <div class="contact-actions">
                    <div class="contact-item">
                      <svg class="icon" viewBox="0 0 24 24" [ngStyle]="{ 'fill': contact.brandColor }">
                        <path
                          d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z">
                        </path>
                      </svg>
                      <a [href]="'tel:' + roles.phone">
                        {{ roles.phone }}
                      </a>
                    </div>
                    <div
                      class="contact-item"
                      [ngStyle]="hoverIndex2 === i ? contact.hoverContactStyle : {}"
                      (mouseenter)="hoverIndex2 = i"
                      (mouseleave)="hoverIndex2 = -1">
                      <svg class="icon" viewBox="0 0 24 24" [ngStyle]="{ 'fill': contact.brandColor }">
                        <path
                          d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z">
                        </path>
                      </svg>
                      <a [href]="'mailto:' + roles.email">
                        {{ roles.email }}
                      </a>
                    </div>
                  </div>
                  <button
                    class="download-btn"
                    type="button"
                    (click)="downloadCard(card)"
                    data-html2canvas-ignore>
                    <svg style="width: 14px; height: 14px; fill: currentColor;" viewBox="0 0 24 24">
                      <path
                        d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z">
                      </path>
                    </svg>
                    Download Contact
                  </button>
                </div>
              </div>
            </div>
          }
        }
      </div>
    }
    <!-- NO DATA -->
    @if (contacts.length === 0 && (searchTriggered$ | async) && !(contactDataLoading$ | async)) {
      <div
        class="alert-info p-3 rounded mt-3"
        >
        No contacts found.
      </div>
    }
  }

</div>


<!-- SPINNER -->
@if (contactDataLoading$ | async) {
  <ng-container class="cx-spinner">
    <cx-spinner class="cx-dialog-popover-center-backdrop"></cx-spinner>
  </ng-container>
}
